export const SITE = {
  name: "Embrace Healthcare",
  legalName: "Embrace Health Care Ltd",
  tagline: "Outstanding domiciliary care in the comfort of your own home",
  phone: "01302 481515",
  phoneHref: "tel:+441302481515",
  email: "enquiries@embracehealthcare.co.uk",
  emailHref: "mailto:enquiries@embracehealthcare.co.uk",
  address: {
    line1: "Clayfield House, Unit 1",
    line2: "Clayfield Industrial Estate",
    line3: "Tickhill Road",
    city: "Doncaster",
    postcode: "DN4 8QG",
  },
  hours: [
    { label: "Care delivery", value: "24 hours a day, 7 days a week" },
    { label: "Office hours", value: "Mon – Fri  •  09:00 – 17:00" },
    { label: "Out of hours", value: "On-call support available" },
  ],
  offices: [
    {
      id: "doncaster",
      city: "Doncaster",
      phone: "01302 481515",
      phoneHref: "tel:+441302481515",
      line1: "Clayfield House, Unit 1",
      line2: "Clayfield Industrial Estate",
      line3: "Tickhill Road",
      postcode: "DN4 8QG",
    },
    {
      id: "leicester",
      city: "Leicester",
      phone: "0116 204 6952",
      phoneHref: "tel:+441162046952",
      line1: "The Old Rectory",
      line2: "Main Street",
      line3: "Leicestershire",
      postcode: "LE3 8DG",
    },
  ],
  social: {
    instagram:
      "https://www.instagram.com/embracehealthcareltd?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw==",
    facebook: "https://www.facebook.com/profile.php?id=100069015699950",
  },
  logo:
    "https://customer-assets.emergentagent.com/job_3636e46a-ffb0-4185-adeb-37077fe840ee/artifacts/77xit3b1_cropped-embraceLogo-1.png",
  imagery: {
    heroBanner:
      "https://customer-assets.emergentagent.com/job_care-at-home-embrace/artifacts/3yagn1az_ChatGPT%20Image%20Jun%2018%2C%202026%2C%2012_27_06%20PM.png",
    heroHome: "https://images.pexels.com/photos/16364307/pexels-photo-16364307.jpeg",
    servicesOverview:
      "https://customer-assets.emergentagent.com/job_care-at-home-embrace/artifacts/6a5jm3ac_ChatGPT%20Image%20Jun%2018%2C%202026%2C%2002_23_52%20PM.png",
    aboutTrust:
      "https://customer-assets.emergentagent.com/job_care-at-home-embrace/artifacts/n85w99u4_ChatGPT%20Image%20Jun%2018%2C%202026%2C%2002_27_31%20PM.png",
    careers:
      "https://customer-assets.emergentagent.com/job_care-at-home-embrace/artifacts/nzijt630_ChatGPT%20Image%20Jun%2018%2C%202026%2C%2003_46_45%20PM.png",
    contactBg: "https://images.pexels.com/photos/18459193/pexels-photo-18459193.jpeg",
  },
};

export const NAV_LINKS = [
  { label: "Home", to: "/", id: "home" },
  { label: "About", to: "/about", id: "about" },
  { label: "Services", to: "/services", id: "services" },
  { label: "Careers", to: "/careers", id: "careers" },
  { label: "Contact", to: "/contact", id: "contact" },
];

export const SERVICES = [
  {
    slug: "personal-care",
    title: "Personal Care",
    icon: "HeartHandshake",
    summary:
      "Discreet, dignified help with bathing, dressing, grooming and continence support — delivered with warmth and respect.",
    hero: "https://customer-assets.emergentagent.com/job_care-at-home-embrace/artifacts/6a5jm3ac_ChatGPT%20Image%20Jun%2018%2C%202026%2C%2002_23_52%20PM.png",
    tagline: "Dignified, respectful support with everyday personal routines.",
    intro:
      "Personal care sits at the heart of what we do. Whether it's a single morning visit or a full daily package, we support people with the tasks that keep them clean, comfortable and confident — always in a way that protects privacy and preserves dignity.",
    included: [
      "Support with bathing, showering, hair and skincare",
      "Help with dressing, undressing and choosing appropriate clothing",
      "Oral care, shaving and grooming",
      "Continence care, catheter and stoma support",
      "Safe assistance with mobility, transfers and repositioning",
      "Monitoring of skin integrity and pressure areas",
    ],
    forWhom: [
      "Older adults living alone or with family",
      "People recovering from illness, injury or hospital discharge",
      "Adults with long-term conditions or physical disability",
      "Anyone who needs a little help to feel their best each day",
    ],
    outcomes: [
      "Feel fresh, comfortable and confident every day",
      "Stay safely at home rather than move into residential care",
      "Reduce falls and skin-related complications",
      "Regain routine, independence and self-esteem",
    ],
  },
  {
    slug: "domestic-support",
    title: "Domestic Support",
    icon: "Home",
    summary:
      "Light housekeeping, laundry, meal preparation and shopping so the home stays comfortable and welcoming.",
    hero: "https://customer-assets.emergentagent.com/job_care-at-home-embrace/artifacts/n85w99u4_ChatGPT%20Image%20Jun%2018%2C%202026%2C%2002_27_31%20PM.png",
    tagline: "A tidy, well-run home — without lifting a finger.",
    intro:
      "A comfortable home makes a huge difference to wellbeing. Our domestic support service takes care of the everyday tasks that can become difficult with age, illness or reduced mobility, so home always feels welcoming and safe.",
    included: [
      "Light cleaning: dusting, vacuuming, kitchen and bathroom",
      "Laundry, ironing and changing bed linen",
      "Meal preparation and light cooking",
      "Grocery shopping, prescription collection and errands",
      "Managing household waste and recycling",
      "Reporting maintenance concerns to family or landlords",
    ],
    forWhom: [
      "Older adults who value their independence at home",
      "People with reduced mobility or fatigue",
      "Family carers who need a helping hand around the house",
      "Anyone recovering from surgery or illness",
    ],
    outcomes: [
      "Live in a clean, safe and organised home",
      "Enjoy freshly prepared meals",
      "Free up time and energy for what matters",
      "Reduce stress on family carers",
    ],
  },
  {
    slug: "medication-support",
    title: "Medication Support",
    icon: "Pill",
    summary:
      "Trained Care Workers prompt, administer and record medication safely in line with best-practice guidance.",
    hero: "https://customer-assets.emergentagent.com/job_care-at-home-embrace/artifacts/6a5jm3ac_ChatGPT%20Image%20Jun%2018%2C%202026%2C%2002_23_52%20PM.png",
    tagline: "Right medication. Right dose. Right time.",
    intro:
      "Managing multiple medications can become confusing — and missed or double doses carry real risk. Our carers are trained to NICE and CQC standards to prompt, administer and record medication safely, working with pharmacists and GPs to keep everyone informed.",
    included: [
      "Prompting or administering oral, topical and inhaled medications",
      "Support with blister packs, MAR charts and PRN records",
      "Ordering repeat prescriptions and pharmacy liaison",
      "Application of creams, eye drops and prescribed dressings",
      "Monitoring for side effects and reporting concerns",
      "Support with controlled drugs where appropriate",
    ],
    forWhom: [
      "People taking multiple daily medications",
      "Adults with memory difficulties who forget doses",
      "Those managing complex conditions such as diabetes or Parkinson's",
      "Anyone recently discharged from hospital",
    ],
    outcomes: [
      "Take medication consistently and safely",
      "Avoid missed or double doses",
      "Reduce hospital admissions related to medication errors",
      "Peace of mind for families",
    ],
  },
  {
    slug: "companionship",
    title: "Companionship",
    icon: "Coffee",
    summary:
      "A friendly visit, a cup of tea, a walk in the garden — meaningful company that reduces isolation.",
    hero: "https://customer-assets.emergentagent.com/job_care-at-home-embrace/artifacts/n85w99u4_ChatGPT%20Image%20Jun%2018%2C%202026%2C%2002_27_31%20PM.png",
    tagline: "Care isn't only about tasks — it's about people.",
    intro:
      "Loneliness has a measurable impact on physical and mental health. Our companionship visits bring warmth, conversation and shared activity — from a chat over tea to a walk in the park or a trip to a favourite café.",
    included: [
      "Conversation, cups of tea, board games and reading together",
      "Accompanied walks, garden time and light exercise",
      "Escort to appointments, church, clubs or the shops",
      "Support with hobbies and social interests",
      "Video calls with family and technology support",
      "A regular friendly face on a consistent rota",
    ],
    forWhom: [
      "Older adults living alone",
      "People whose family live far away",
      "Recently bereaved individuals",
      "Anyone experiencing social isolation or low mood",
    ],
    outcomes: [
      "Feel connected and less isolated",
      "Improved mood and mental wellbeing",
      "Stay socially and physically active",
      "Reassurance for family living at a distance",
    ],
  },
  {
    slug: "dementia-care",
    title: "Dementia Care",
    icon: "Brain",
    summary:
      "Specialist dementia-trained carers who bring familiarity, calm and structure to each visit.",
    hero: "https://customer-assets.emergentagent.com/job_care-at-home-embrace/artifacts/3yagn1az_ChatGPT%20Image%20Jun%2018%2C%202026%2C%2012_27_06%20PM.png",
    tagline: "Familiar faces. Gentle routines. Person-first support.",
    intro:
      "For people living with dementia, familiarity is everything. Our dementia-trained carers work in dedicated runs so the same trusted faces support the same clients — reducing anxiety, respecting the person behind the diagnosis and gently keeping routines that feel safe and predictable.",
    included: [
      "Consistent care teams trained in dementia and Alzheimer's care",
      "Person-centred routines that reflect life history and preferences",
      "Support with memory prompts, orientation and reassurance",
      "Managing challenging moments with calm, positive strategies",
      "Nutrition, hydration and medication monitoring",
      "Close communication with families and memory services",
    ],
    forWhom: [
      "People living with any stage of dementia",
      "Adults with mild cognitive impairment",
      "Families providing daily support who need respite",
      "Individuals moving home to home post-diagnosis",
    ],
    outcomes: [
      "Stay in familiar surroundings for longer",
      "Reduce distress, agitation and wandering incidents",
      "Maintain identity, hobbies and daily rhythm",
      "Support the whole family, not just the individual",
    ],
  },
  {
    slug: "end-of-life-care",
    title: "End of Life Care",
    icon: "Sunset",
    summary:
      "Sensitive, dignified end-of-life support at home, working alongside district nurses, GPs and families.",
    hero: "https://customer-assets.emergentagent.com/job_care-at-home-embrace/artifacts/n85w99u4_ChatGPT%20Image%20Jun%2018%2C%202026%2C%2002_27_31%20PM.png",
    tagline: "Comfort, dignity and choice in the place you call home.",
    intro:
      "Most people wish to spend their final days at home, surrounded by the people and things they love. Our end-of-life care team supports service users, families and healthcare partners with sensitivity, expertise and unwavering respect — from planning conversations through to bereavement.",
    included: [
      "Symptom management and comfort care in line with the care plan",
      "Close collaboration with district nurses, GPs and hospice teams",
      "Support with personal care, mouth care and repositioning",
      "Advance care planning and preferred priorities of care",
      "Emotional support for the person and their family",
      "Overnight sits and waking-night support where required",
    ],
    forWhom: [
      "Adults with a life-limiting condition",
      "People discharged from hospital or hospice to die at home",
      "Families needing extra support in the final weeks and days",
      "Anyone wishing to plan ahead with dignity",
    ],
    outcomes: [
      "Remain at home with the people you love",
      "Physical comfort and effective symptom control",
      "Peace of mind for family carers",
      "A calm, dignified experience honoured to the end",
    ],
  },
  {
    slug: "complex-care",
    title: "Complex Care",
    icon: "Stethoscope",
    summary:
      "Tailored support for people with complex health needs — including PEG feeding, catheter care and wound care.",
    hero: "https://customer-assets.emergentagent.com/job_care-at-home-embrace/artifacts/6a5jm3ac_ChatGPT%20Image%20Jun%2018%2C%202026%2C%2002_23_52%20PM.png",
    tagline: "Specialist clinical support delivered in the home.",
    intro:
      "For people living with long-term conditions, spinal-cord injuries, neurological illness or complex health needs, we build bespoke care packages led by senior carers with specialist competency-based training and ongoing clinical oversight.",
    included: [
      "PEG feeding, tracheostomy and ventilator support",
      "Catheter, stoma and bowel management",
      "Complex wound and pressure area care",
      "Rehabilitation support post-stroke or brain injury",
      "Care for people with MND, MS, Parkinson's and Huntington's",
      "24-hour and live-in packages where required",
    ],
    forWhom: [
      "Adults with neurological or long-term conditions",
      "People with spinal injuries or acquired disabilities",
      "Individuals discharged from hospital with complex needs",
      "Families managing a diagnosis at home for the first time",
    ],
    outcomes: [
      "Live safely at home with the right clinical support",
      "Reduce hospital admissions and readmissions",
      "Maintain quality of life and personal goals",
      "Coordinated, joined-up care across the whole team",
    ],
  },
  {
    slug: "respite-care",
    title: "Respite Care",
    icon: "Sparkles",
    summary:
      "Short-term cover that gives family carers the chance to rest, knowing their loved one is in safe hands.",
    hero: "https://customer-assets.emergentagent.com/job_care-at-home-embrace/artifacts/3yagn1az_ChatGPT%20Image%20Jun%2018%2C%202026%2C%2012_27_06%20PM.png",
    tagline: "Take a breath. We'll take excellent care of them.",
    intro:
      "Family carers do extraordinary work — but everyone needs a break. Our respite service steps in for a few hours, a few days, or longer, allowing family carers to rest, work, travel or simply recharge, safe in the knowledge their loved one is in kind, competent hands.",
    included: [
      "Planned respite visits from short calls to full days",
      "Overnight and live-in respite by arrangement",
      "Support with personal care, meals and medication",
      "Companionship and social activity",
      "Continuity with the person's existing routine",
      "Emergency short-notice respite where possible",
    ],
    forWhom: [
      "Family carers who need regular breaks",
      "Carers planning a holiday, hospital stay or work commitment",
      "Families experiencing carer burnout",
      "Anyone testing the idea of home care for the first time",
    ],
    outcomes: [
      "Prevent carer burnout and safeguard family wellbeing",
      "Maintain continuity of care for your loved one",
      "Peace of mind while you're away",
      "Sustainable long-term family caring arrangements",
    ],
  },
];

export const VALUES = [
  {
    icon: "User",
    title: "Person-Centred Care",
    body:
      "Every individual is different. We listen first — to routines, preferences, culture and goals — then build a care plan around the person, not the task list.",
  },
  {
    icon: "Wind",
    title: "Promoting Independence",
    body:
      "Our goal is not simply to provide care, but to empower people to remain active, engaged and in control of their daily lives.",
  },
  {
    icon: "Users",
    title: "Consistent Care Teams",
    body:
      "Dedicated runs mean familiar faces. The team gets to know each person well — and spots changes in health or wellbeing early.",
  },
  {
    icon: "GraduationCap",
    title: "Highly Trained Professionals",
    body:
      "Ongoing training in dementia, medication, moving & handling, wound care, end-of-life, safeguarding, complex conditions, mental health and nutrition.",
  },
  {
    icon: "PhoneCall",
    title: "Responsive & Reliable",
    body:
      "We maintain regular contact with families, social workers, district nurses and GPs so support is joined-up and dependable.",
  },
  {
    icon: "ShieldCheck",
    title: "Safe, Quality-Assured",
    body:
      "Fully regulated by the Care Quality Commission (CQC). We work to national standards and continuously improve the care we deliver.",
  },
];

export const TRAINING_AREAS = [
  { slug: "dementia", label: "Dementia Care" },
  { slug: "medication", label: "Medication Management" },
  { slug: "moving-handling", label: "Moving and Handling" },
  { slug: "wound-care", label: "Wound Care" },
  { slug: "end-of-life", label: "End of Life Care" },
  { slug: "safeguarding", label: "Safeguarding" },
  { slug: "complex-health", label: "Complex Health Conditions" },
  { slug: "mental-health", label: "Mental Health Awareness" },
  { slug: "nutrition", label: "Nutrition and Hydration" },
];

export const OUTCOMES = [
  "Remain safely in your own home for longer",
  "Avoid unnecessary hospital admissions",
  "Recover successfully following hospital discharge",
  "Maintain independence and daily living skills",
  "Improve emotional wellbeing and reduce social isolation",
  "Receive dignified, respectful, compassionate care",
];

export const CARE_OPTIONS = [
  "Personal Care",
  "Domestic Support",
  "Medication Support",
  "Companionship",
  "Dementia Care",
  "End of Life Care",
  "Complex Care",
  "Respite Care",
  "Not sure yet — please advise",
];

export const CONTACT_TIME_OPTIONS = [
  "Anytime",
  "Morning (8am – 12pm)",
  "Afternoon (12pm – 5pm)",
  "Evening (5pm – 8pm)",
];

export const PARTNERS = [
  {
    name: "City of Doncaster Council",
    short: "Doncaster Council",
    url: "https://customer-assets.emergentagent.com/job_care-at-home-embrace/artifacts/eaxn05wj_image.png",
  },
  {
    name: "Leicester City Council",
    short: "Leicester Council",
    url: "https://customer-assets.emergentagent.com/job_care-at-home-embrace/artifacts/4hdapxvl_image.png",
  },
  {
    name: "Care Quality Commission",
    short: "CQC Regulated",
    url: "https://customer-assets.emergentagent.com/job_care-at-home-embrace/artifacts/3hld0vs5_image.png",
    scale: 1.5,
  },
  {
    name: "NHS",
    short: "NHS",
    url: "https://customer-assets.emergentagent.com/job_care-at-home-embrace/artifacts/nsltkau5_image.png",
  },
  {
    name: "Care Sourcer — People deserve better",
    short: "Care Sourcer",
    url: "https://customer-assets.emergentagent.com/job_care-at-home-embrace/artifacts/mko9bshi_image.png",
    scale: 1.5,
  },
  {
    name: "Care Choices",
    short: "Care Choices",
    url: "https://customer-assets.emergentagent.com/job_care-at-home-embrace/artifacts/k2iahcp6_image.png",
    scale: 1.5,
  },
  {
    name: "homecare.co.uk",
    short: "Homecare.co.uk",
    url: "https://customer-assets.emergentagent.com/job_care-at-home-embrace/artifacts/8vvtai8y_image.png",
    scale: 1.5,
  },
];
